<era-note [editMode]="true"
          (addedEvent)="noteAdded($event)"></era-note>
@for (note of notes; track note) {
<div id="notes">
  <era-note [note]="note"
            (deletedEvent)="noteDeleted($event)"></era-note>
</div>
}